import {Deserializable} from '../deserializable';
import {DocumentDraftFile} from '../draft/documentdraftfile';
import {ThuFile} from './thufile';
import {Staffs} from '../staff/staffs';


export  class ThuTemp implements Deserializable
{
  public  id: number;
  public  vanDe: string;
  public  noiDung: string;
  public  noiDungShort: string;
  public  ngayNhap: string;
  public  nguoiTao: number;
  public  tenNguoitao: string;
  public  nguoinhanTen: string;
  public  nguoiNhan: number;
  public  timeAd: string;
  public  timeReply: string;
  public  checkread: number;
  public  thoiHan: string;
  public  suDung: number;
  public  ngayTao: string;
  public  flagConfirm: number;
  public thuFiles: ThuFile[];
  public nguoiNhanItem: Staffs;
  public nguoiTaoItem: Staffs;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.thuFiles = input.thuFiles.map(thuFiles => new ThuFile().deserialize(thuFiles));
    this.nguoiNhanItem = input.nguoiNhanItem != null? new Staffs().deserialize(input.nguoiNhanItem): null;
    this.nguoiTaoItem = input.nguoiTaoItem != null? new Staffs().deserialize(input.nguoiTaoItem): null;
    return this;
  }
}
